import { createRouter, createWebHistory } from 'vue-router'
import global from '@/global'
const {authenticated,requestAuth,closeSideBar} = global



const routes = [

// Unauthenticated - Auth
  {
    path: '/login',
    name: 'Login',
    component: ()=>import('@/views/Login.vue'),
    meta: {
      title: 'DLSTracker - Login'
    },
    props: true,
    beforeEnter: async (to, from, next) => {
      // requestAuth resolves when another tab's answer signs this tab in, or after 300ms, and never
      // returns the auth payload. Success shows as authenticated.loggedIn.
      await requestAuth();
      const redirectTarget = sessionStorage.getItem('redirectTarget') || '/';

      // Only clear the saved target on the branch that consumes it. Clearing it unconditionally lost
      // the bookmarked destination whenever the handshake had not landed yet, and every later
      // redirect then fell back to '/'.
      if (authenticated.value.loggedIn) {
        console.log('Already authenticated. Redirecting.');
        sessionStorage.removeItem('redirectTarget');
        next(redirectTarget);
      } else {
        console.log('No authentication found. Proceeding to Login.');
        next();
      }
    }
  },
  {
    path: '/forgotpassword',
    name: 'Forgot Password',
    component: ()=>import('@/views/ForgotPassword.vue'),
    beforeEnter(to, from, next) {
      console.log('beforeEnter guard executed for /forgotpassword');
      console.log('Authenticated:', authenticated.value.loggedIn);
      if(!authenticated.value.loggedIn) {next()} else { next({ name: 'Home' })}
    }
  },
  {
    path: '/resetpassword/:resetToken',
    name: 'Reset Password',
    component: ()=>import('@/views/ResetPassword.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path: '/verifyaccount/:verifytoken',
    name: 'VerifyAccount',
    component: () => import('../components/VerifyAccount.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },

// Unauthenticated - External / Client Portal
  {
    path:'/external/integratorFormRequests/:accessCode/:integratorFormRequestId',
    name:'Integrator Information Form',
    component: ()=>import('@/components/companies/IntegratorInformationform.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path:'/external/:projectId/:secureCode',
    name:'External',
    component: ()=>import('@/components/external/ExternalEquipmentTracker.vue'),
    beforeEnter(to,from,next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path:'/external/roomTracker/:projectId/:secureCode',
    name: 'ExternalRoomTracker',
    component: ()=>import('@/components/external/ExternalRoomTracker.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path:'/external/photos/:projectId/:secureCode',
    name: 'ExternalProjectPhotos',
    component: ()=>import('@/components/external/ExternalProjectPhotos.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path: '/external/rma/:accessCode/:rmaId',
    name: 'ExternalRMA',
    component: () => import('@/components/external/ExternalRMA.vue'),
    beforeEnter(to, from, next) {
      !authenticated.value.loggedIn ? next() : next({ name: 'Home' })
    }
  },
  {
    path:'/equipment/damage/:equipmentId',
    name: 'EquipmentDamageReview',
    component: ()=>import('@/components/logistics/EquipmentDamageReview.vue'),
    meta:{
      title: 'Damage Report',
      hideHeader:true
    }
  },

// Core Pages
  {
    // Sign-in prompts (work order Step 7): needs a signed-in user; with none queued it goes on to the saved target.
    path: '/signin-prompts',
    name: 'Sign-in Prompts',
    component: () => import('@/views/SignInPrompts.vue'),
    meta: { title: 'DLSTracker' },
    beforeEnter(to, from, next) {
      if (sessionStorage.getItem('signInPrompts')) { next() }
      else { const target = sessionStorage.getItem('redirectTarget') || '/'; sessionStorage.removeItem('redirectTarget'); next(target) }
    }
  },
  {
    path: '/',
    name: 'Home',
    component: ()=>import('../components/home/Home.vue'),
    meta: { title: 'Home' },
    props: true
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      hideHeader: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  //{
  //  path: '/error',
  //  name: 'Error',
  //  component: ()=>import('@/components/Error.vue'),
  //  props: true,
  //  beforeEnter(to, from, next) {
  //    if (to.params.status) { next() }
  //    else next({ name: 'Home' })
  //  }
  //},
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/components/Error.vue'),
    props: route => ({
      status: route.query.status,
      message: route.query.message
    }),
    beforeEnter(to, from, next) {
      // Only allow navigation if a status is present in query
      if (to.query.status) {
        next();
      } else {
        next({ name: 'Home' });
      }
    }
  },

// My Account
  {
    path: '/myAccount',
    name: 'My Account',
    component: () => import('@/components/myAccount/MyAccount')
  },

// Time Management
  {
    path: '/pto',
    name: 'RequestPTO',
    component: () => import('../components/timeManagement/PTO/PTO.vue'),
    meta:{
      title:'PTO Requests',
      accessControl:{pto:1}
    }
  },
  //{
  //  path: '/timesheets',
  //  name: 'Timesheets',
  //  component: () => import('../components/timeManagement/timesheets/TimeSheetsUser.vue'),
  //  meta:{
  //    primeOnly:true,
  //    timesheet:true
  //  }
  //},
  {
    path: '/timecards',
    name: 'Timesheets',
    component: () => import('../components/timeManagement/timecards/Timecards.vue'),
    meta:{
      primeOnly:true,
      timesheet:true
    }
  },
  {
    path:'/payroll',
    name:'Payroll',
    component: ()=> import('../components/timeManagement/timecards/Payroll.vue'),
    meta:{
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/specialRates',
    name:'Special Rates',
    component: ()=> import('../components/timeManagement/timecards/SpecialRates.vue'),
    meta:{
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/approveTimecards',
    name:'Approve Timesheets',
    component:()=>import('@/components/timeManagement/timecards/TimecardApproval.vue'),
    meta: {
      title:'Approve Timesheets',
      primeOnly:true,
      accessControl:{approveTimesheets:1}
    }
  },
  //{
  //  path:'/approveTimesheets',
  //  name:'Approve Timesheets',
  //  component :()=> import('@/components/timeManagement/timesheets/TimesheetApproval.vue'),
  //  meta: {
  //    title:'Approve Timesheets',
  //    primeOnly:true,
  //    accessControl:{approveTimesheets:1}
  //  }
  //},
  {
    path: '/timeclock',
    name: 'Time Clock',
    component: ()=> import ('../components/timeManagement/WorkTime.vue'),
  },
  {
    path: '/timeclockAdmin',
    name: 'Timeclock Admin',
    component:()=> import('@/components/timeManagement/AllUsersClockedTime.vue'),
    meta:{
      title:'Timeclock Admin',
      accessControl:{approveTimesheets:1}
    }
  },
  {
    path:'/myTimeclocks',
    name:'My Timeclock',
    component:()=>import('@/components/timeManagement/AllUsersClockedTime.vue'),
    props:{userOnly:true},
    meta:{
      timesheet:true
    }
  },
  {
    path:'/ptoPlans',
    name:'PTO Plans',
    component:()=>import('@/components/timeManagement/ptoPlans/PTOPlans.vue'),
    meta:{
      title:'PTO Plans',
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/employeePTOInfo',
    name:'Employee Info',
    component:()=>import('@/components/timeManagement/employeeInfo/EmployeePTOInfo.vue'),
    meta:{
      title:'Employee Info',
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/sickTime',
    name:'Sick Time',
    component:()=>import('@/components/timeManagement/sickTime/sickTime'),
    meta:{
      title:'Sick Time Plans',
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/employeeSickTime',
    name:'Employee Sick Time',
    component:()=>import('@/components/timeManagement/employeeInfo/EmployeeSickTimeInfo.vue'),
    meta:{
      title:'Employee Sick Time Info',
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },
  {
    path:'/holidays',
    name:'Company Holidays',
    component:()=>import('@/components/timeManagement/holidays/Holidays.vue'),
    meta:{
      title:'Company Holidays',
      primeOnly:true,
      accessControlAny:{payroll:1,scheduling:1}
    }
  },

// Users
  {
    path: '/users',
    name: 'Users',
    component: () => import('../components/users/Users.vue'),
    meta: {
      title: 'Users',
      accessControl:{'manageAccounts':1}
    }
  },

// Projects
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('../components/projects/ViewProjects.vue'),
    meta: {
      title: 'Projects',
      role: 0,
      accessControl:{projects:1}
    }
  },
  // Links used to end in /true (open without a back arrow). Old bookmarks and pasted links still carry it.
  {
    path: '/project/:projectId/true',
    redirect: to => ({ name: 'Project', params: to.params, query: to.query, hash: to.hash })
  },
  {
    path: '/project/:projectId',
    name: 'Project',
    component:()=>import('@/components/projects/Project.vue'),
    meta: {
      title: 'Project',
      accessControl: {projects:1},
      hideHeader:true
    }
  },
  {
    path:'/newProject',
    name: 'New Project',
    component:()=>import('../components/projects/newProject/newProject.vue'),
    meta:{
      title:'New Project',
      primeOnly:true,
      accessControl:{projects:3}
    }
  },
  {
    path:'/projectSearchV2',
    name: 'Project Search V2',
    component:()=>import('../components/projects/search/ProjectSearchV2.vue'),
    meta:{
      title:'Search Projects',
      accessControlAny:{projects:1,projectView:1}
    }
  },

// Invoicing
  {
    path:'/invoices',
    name:'Invoices',
    component:()=>import('@/components/invoices/Invoices.vue'),
    meta:{
      title:'Invoices',
      primeOnly:true,
      accessControlAny:{projects:4,invoices:1}
    }
  },
  {
    path:'/openInvoices',
    name:'Open Invoices',
    component:()=>import('@/components/invoices/OpenInvoicesByCustomer.vue'),
    meta:{
      title:'Open Invoices',
      primeOnly:true,
      accessControlAny:{projects:4,invoices:1}
    }
  },
  {
    path:'/invoiceRequests',
    name:'Invoice Requests',
    component: () => import('../components/invoices/InvoiceRequests.vue'),
    meta: {
      title: 'Invoice Requests',
      primeOnly:true,
      accessControl:{invoices:1}
    }
  },
  {
    path:'/vendorInvoices',
    name:'Vendor Invoices',
    component:()=>import('@/components/vendorInvoices/VendorInvoices.vue'),
    meta:{
      title:'Vendor Invoices',
      primeOnly:true,
      accessControlAny:{projects:4,payroll:1}
    }
  },
  {
    path:'/closedVendorInvoices',
    name:'Closed Vendor Invoices',
    component:()=>import('@/components/vendorInvoices/ClosedVendorInvoices.vue'),
    meta:{
      title:'Closed Vendor Invoices',
      primeOnly:true,
      accessControl:{payroll:1}
    }
  },

  // Organizations / Companies
  {
    path: '/organization/:organizationId',
    name: 'Organization',
    component: () => import('../components/companies/ViewCompany.vue'),
    meta: {
      title: 'Organization',
      accessControl: {organizations:1},
      hideHeader:true
    }
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('../components/companies/Companies.vue'),
    meta: {
      title: 'Companies',
      accessControl: {organizations:1}
    }
  },
  {
    path: '/integratorInformationForms',
    name: 'Integrator Information Forms',
    component: () => import('../components/companies/IIFForms.vue'),
    meta: {
      title: 'Integrator Information Forms',
      primeOnly:true,
      accessControl: {organizations:3},
    }
  },
  {
    path: '/newIntegrator/:id',
    name: 'New Integrator',
    component: () => import('@/components/companies/NewIntegrator.vue'),
    meta: {
      title: 'New Integrator',
      primeOnly:true,
      accessControl: {organizations:1},
    }
  },
  {
    path:'/newBranch',
    name:'New Branch',
    component:()=>import('@/components/companies/NewBranch.vue'),
    meta:{
      title:'New Branch',
      primeOnly:true,
      accessControl:{organizations:3}
    }
  },
  {
    path:'/newSubContractor',
    name:'New SubContractor',
    component:()=>import('@/components/companies/NewSubContractor.vue'),
    meta:{
      title:'New Sub-Contractor',
      primeOnly:true,
      accessControl:{organizations:3}
    }
  },

// Warehouse & Equipment
  {
    path: '/equipmentSearch',
    name: 'Equipment Search',
    component: () => import('../components/equipment/EquipmentSearch.vue'),
    meta: {
      title: 'Equipment Search',
      accessControl: { projects: 1, projectView: 1 },
      hideHeader:true
    }
  },
  {
    path: '/receiveEquipment',
    name: 'Receive Equipment',
    component: () => import('../components/warehouse/receiving/ReceiveEquipment.vue'),
    meta: {
      title: 'Receiving Equipment',
      primeOnly:true,
      accessControl:{receiving:1},
      hideHeader:true
    }
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('../components/equipment/Tools.vue'),
    meta: {
      title: 'Tools',
      primeOnly:true,
      accessControl:{warehouseQueue:1}
    }
  },
  {
    path: '/vehicleManagement',
    name: 'Vehicles',
    component: () => import('../components/vehicles/VehicleManagement.vue'),
    meta: {
      title: 'Vehicles',
      primeOnly:true,
      accessControl:{warehouseQueue:1}
    }
  },
  {
    path:'/shippingRequests',
    name:'Warehouse Requests',
    component: () => import('../components/warehouse/ShippingRequests.vue'),
    meta: {
      title: 'Warehouse Requests',
      accessControl:{warehouseQueue:1}
    }
  },
  {
    path:'/rackBuildRequests',
    name:'Rack Requests',
    component: () => import('@/components/warehouse/rackBuilds/RackBuildRequests.vue'),
    meta: {
      title: 'Rack Requests',
      accessControl:{rackQueue:1}
    }
  },
  {
    path:'/printLabels',
    name:'Labels',
    component:()=>import('../components/equipment/PrintLabels.vue'),
    meta:{
      title:'Labels',
      accessControlAny:{warehouseQueue:1,rackQueue:1}
    }
  },

// Scheduling
  {
    path: '/scheduleResources',
    name: 'Schedule Resources',
    component: ()=>import('@/components/scheduling/resources/Schedule.vue'),
    meta: {
      title: 'Schedule Resources',
      primeOnly:true
      //accessControl:{scheduling:1}
    },
    props: true
  },
  {
    path:'/shipmentSchedule',
    name:'Shipment Schedule',
    component:()=>import('@/components/warehouse/schedule/ShipmentSchedule.vue'),
    props:{inModal:false},
    meta:{
      title:'Shipment Schedule',
      primeOnly:true,
      accessControlAny:{warehouseQueue:1,projects:2}
    }
  },

// Logistics
  {
    path:'/deviceCatalog',
    name:'Device Catalog',
    component:()=>import('@/components/logistics/catalog/DeviceCatalog.vue'),
    meta:{
      title:'Catalog',
      primeOnly:true,
      // The warehouse team (receiving / warehouse queue / rack queue). Manager-only actions are gated inside the page.
      accessControlAny:{receiving:1,warehouseQueue:1,rackQueue:1}
    }
  },
  {
    path:'/boxLabel/:labelId',
    name:'Box Label',
    component:()=>import('@/components/logistics/ViewFromLabel.vue'),
    meta:{
      title:'Box Label',
      primeOnly:true,
      hideHeader:true
    }
  },

// Reports
  {
    path:'/reports/PTOReports',
    name:'PTO Reports',
    component:()=>import('@/components/reports/pto/PtoOrganizationReport.vue'),
    meta:{
      title:'PTO Reports',
      primeOnly:true,
      accessControlAny:{payroll:1,approveTimesheets:1}
    }
  },

// Digital Signage
  {
    path:'/signage/warehouse',
    name:'WarehouseDashboard',
    component:()=>import('@/components/digitalSignage/WarehouseDigitalSignage.vue'),
    meta:{
      title:'Warehouse Dashboard'
    }
  },

// Admin
  {
    path:'/admin/ActiveConnections',
    name:'Active Connections',
    component:()=>import('@/components/admin/ActiveConnections.vue'),
    meta:{
      title:'Active Connections',
      primeOnly:true,
      adminOnly:true,
      hideHeader:true
    }
  },
  {
    path:'/admin/ButtonsAndColors',
    name:'Buttons and Colors',
    component:()=>import('@/components/admin/ButtonsAndColors.vue'),
    meta:{
      title:'Buttons and Colors',
      primeOnly:true,
      adminOnly:true
    }
  },

// Data Management
  {
    path: '/DataManagement',
    name: 'DataManagement',
    component: () => import('../components/applicationData/DataManagement.vue'),
    props: true,
    meta: {
      title: 'Data Management'
    }
  },

  // 404 Fallback (must remain last)
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    component: ()=>import('@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  hash: false,
  routes
})

// Recover from chunk load failures after a deploy (stale client referencing a chunk that no longer exists).
// Reload once per navigation target; a sessionStorage guard prevents a reload loop if the chunk is genuinely missing.
router.onError((error, to) => {
  const isChunkError = /ChunkLoadError|Loading chunk .+ failed/i.test(error?.message || '')
  if (!isChunkError) return
  const key = `chunkReload:${to?.fullPath || location.pathname}`
  if (sessionStorage.getItem(key)) return
  sessionStorage.setItem(key, '1')
  window.location.assign(to?.fullPath || location.pathname)
})


// maintains global auth state on refresh, redirects to intended target after login & nav guard for authenticated users
router.beforeEach(async (to, from, next) => {
  // save original target if not authenticated
  const redirectTarget = to.fullPath || '/'
  // sets display title of document
  document.title = to.meta.title || to.name
  closeSideBar()
  //if (sessionStorage.getItem("refresh") === sessionStorage.getItem("refresh")) { await authOnRefresh() }
  window.scrollTo(0, 0) //set scroll position to top when changing router views

  // redirects to login if not authenticated unless target is in toList (no auth required)
  const unauthenticatedRoutes = ['Login', 'Forgot Password', 'Reset Password', 'VerifyAccount','External','ExternalRoomTracker','ExternalProjectPhotos','WarehouseDashboard','Not Found','Integrator Information Form','ExternalRMA']

  if (!unauthenticatedRoutes.includes(to.name) && !authenticated.value.loggedIn) {
    sessionStorage.setItem("redirectTarget", redirectTarget)
    next({ name: 'Login',query: { redirect: redirectTarget }}); // Send redirectTarget as a query param
  } else {
    next();
  }
})

// navigation guard: primeOnly, timesheet, adminOnly are independent AND-gates;
// accessControl, accessControlAny, and minRole form an OR-group (see below).
router.beforeEach((to, from, next) => {
  //if (to.meta.primeOnly) {
  //  !authenticated.value.organization?.orgType?.includes('primary')
  //  ? next({ name: 'Error', params: { status: 403, message: 'Access Denied: Internal Only.' }, query: to.query })
  //  : next()
  //} else if (to.meta.accessControl) {
  //  !Object.keys(to.meta.accessControl).every((key)=>{return authenticated.value.role.accessModel[key] >= to.meta.accessControl[key]})
  //  ? next({ name: 'Error', params: { status: 403, message: 'Access Denied.' } , query: to.query}) : next()
  //} else if (to.meta.accessControlAny) {
  //  (Object.keys(to.meta.accessControlAny).filter((a)=> authenticated.value.role.accessModel[a] >= to.meta.accessControlAny[a]).length === 0)
  //  ? next({ name: 'Error', params: { status: 403, message: 'Access Denied at Access Control Any.' }, query: to.query }) : next()
  //} else if (to.meta.timesheet && to.meta.timesheet === true) {
  //  !authenticated.value.timesheet ? next({ name: 'Error', params: { status: 403, message: 'Access Denied.' }, query: to.query }) : next()
  //} else if (to.meta.adminOnly) {
  //  authenticated.value.role?.level > 9
  //  ? next({ name: 'Error', params: { status: 403, message: 'Access Denied: Internal Only.' }, query: to.query })
  //  : next()
  //} else {
  //  next()
  //}

  const role = authenticated.value.role || {};
  const accessModel = role.accessModel || {};

  // Check for primeOnly access
  if (to.meta.primeOnly && !authenticated.value.organization?.orgType?.includes('primary')) {
    return next({ name: 'Error', query: { ...to.query, status: 403, message: 'Access Denied: Internal Only.' } });
  }

  // OR-gate group: accessControl (all perms), accessControlAny (any perm), minRole (role.level >= n).
  // A gate is null when its meta key is absent, so only defined gates participate. Access is granted
  // when at least one defined gate passes; 403 only when every defined gate fails.

  // accessControl — user must meet ALL listed accessModel permissions
  const hasAccessControl = to.meta.accessControl
    ? Object.entries(to.meta.accessControl).every(([key, level]) => accessModel[key] >= level)
    : null;

  // accessControlAny — user must meet AT LEAST ONE listed accessModel permission
  const hasAccessControlAny = to.meta.accessControlAny
    ? Object.entries(to.meta.accessControlAny).some(([key, level]) => accessModel[key] >= level)
    : null;

  // minRole — user's role.level must be >= the specified number
  const hasMinRole = typeof to.meta.minRole === 'number'
    ? (role.level || 0) >= to.meta.minRole
    : null;

  const gates = [hasAccessControl, hasAccessControlAny, hasMinRole].filter(g => g !== null);
  if (gates.length > 0 && !gates.some(g => g === true)) {
    return next({ name: 'Error', query: { ...to.query, status: 403, message: 'Access Denied.' } });
  }

  // Check for timesheet access
  if (to.meta.timesheet && !authenticated.value.timesheet) {
    return next({ name: 'Error', query: { ...to.query, status: 403, message: 'Access Denied.' } });
  }

  // Check for adminOnly access
  if (to.meta.adminOnly && (!role.level || role.level < 10)) {
    return next({ name: 'Error', query: { ...to.query, status: 403, message: 'Access Denied: Admin Only.' } });
  }

  next();
})


export default router
